module.exports = "<p>\n  dashboard works! - genesis 19jui2019 16h24 \n</p>\n"